// components/ComponentMap.ts

import HeroSectionV2Container from "../banner/v2/HeroSectionV2Container";
import HeaderWrapper from "../header/HeaderWrapper";
import TopSellingWithBanner from "../product/TopSellingWithBanner";
import CategoryWithSlider from "../category/CategorySlider";
import SiteFeature from "../homepage/SiteFeature";
import TriplePromotionalBanner from "../promotional/TriplePromotionalBanner";
import FooterV2 from "../footer/FooterV2";

import AdditionalSlider from "../banner/AdditionalSliders";
import SliderWithOnePromo from "../banner/SliderWithOnePromo";
import TrendingCategoriesV2 from "../category/TrendingCategoriesV2";
import BrandLogoSliderV2 from "../brand/BrandLogoSliderV2";

export const ComponentMap: Record<
  string | number,
  React.ComponentType<Record<string, unknown>>
> = {

  // String section types from backend API (/api/home-page)
  CATEGORIES: CategoryWithSlider,
  CATEGORY_PRODUCTS: TrendingCategoriesV2,
  BRANDS: BrandLogoSliderV2,
  SLIDERS: SliderWithOnePromo,
  BANNERS: HeroSectionV2Container as React.ComponentType<Record<string, unknown>>,
  PROMO_CARDS: TriplePromotionalBanner,
  TOP_SELLING: TopSellingWithBanner,
  SITE_FEATURE: SiteFeature,


  // Legacy numeric IDs mapping
  1: HeaderWrapper,
  2: HeroSectionV2Container,
  3: TrendingCategoriesV2,
  4: TopSellingWithBanner,
  5: CategoryWithSlider,
  6: SliderWithOnePromo,
  9: SiteFeature,
  10: AdditionalSlider,
  12: TriplePromotionalBanner,
  13: FooterV2,
  15: BrandLogoSliderV2,
};

